export default "__VITE_ASSET__BNjGDsXS__"